import React, { Component } from "react";
import { Box } from "@mui/material";

class LoadingProgressBar extends Component {
  componentDidMount() {
    const keyframes = `
      @keyframes dotAnimation {
        0%, 80%, 100% { transform: scale(0); }
        40% { transform: scale(1); }
      }
    `;

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = keyframes;
    document.head.appendChild(styleSheet);
  }

  render() {
    const styles = {
      container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#ffffff60",
      },
      dotContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
        marginBottom: "30px",
      },
      dot: {
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        animation: "dotAnimation 1.5s infinite ease-in-out",
      },
    };

    const dotColors = ["#F2A33F", "#CF3A2B", "#5EAC41", "#3272B1", "#F2A33F"];
    
    return (
      <Box style={styles.container}>
        <Box style={styles.dotContainer}>
          {dotColors.map((color, index) => (
            <div
              key={index}
              style={{ ...styles.dot, backgroundColor: color, animationDelay: `${index * 0.3}s` }}
            />
          ))}
        </Box>
      </Box>
    );
  }
}

export default LoadingProgressBar;